import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const listProducts = () => api.get("/products").then((r) => r.data);
export const getProduct = (slug) => api.get(`/products/${slug}`).then((r) => r.data);
export const createProduct = (data) => api.post("/products", data).then((r) => r.data);
export const deleteProduct = (id) => api.delete(`/products/${id}`).then((r) => r.data);

export const listFarmers = () => api.get("/farmers").then((r) => r.data);
export const createFarmer = (data) => api.post("/farmers", data).then((r) => r.data);
export const deleteFarmer = (id) => api.delete(`/farmers/${id}`).then((r) => r.data);

export const listFPOs = () => api.get("/fpos").then((r) => r.data);
export const createFPO = (data) => api.post("/fpos", data).then((r) => r.data);
export const deleteFPO = (id) => api.delete(`/fpos/${id}`).then((r) => r.data);

export const listBuyers = () => api.get("/buyers").then((r) => r.data);
export const createBuyer = (data) => api.post("/buyers", data).then((r) => r.data);
export const deleteBuyer = (id) => api.delete(`/buyers/${id}`).then((r) => r.data);

export const listInquiries = () => api.get("/inquiries").then((r) => r.data);
export const createInquiry = (data) => api.post("/inquiries", data).then((r) => r.data);
export const deleteInquiry = (id) => api.delete(`/inquiries/${id}`).then((r) => r.data);

export const listFarmerProfiles = (params = {}) => api.get("/farmer-profiles", { params }).then((r) => r.data);
export const getFarmerProfile = (id) => api.get(`/farmer-profiles/${id}`).then((r) => r.data);
export const createFarmerProfile = (data) => api.post("/farmer-profiles", data).then((r) => r.data);
export const updateFarmerProfile = (id, data) => api.patch(`/farmer-profiles/${id}`, data).then((r) => r.data);
export const deleteFarmerProfile = (id) => api.delete(`/farmer-profiles/${id}`).then((r) => r.data);

export const listOrchards = (params = {}) => api.get("/orchards", { params }).then((r) => r.data);
export const createOrchard = (data) => api.post("/orchards", data).then((r) => r.data);
export const updateOrchard = (id, data) => api.patch(`/orchards/${id}`, data).then((r) => r.data);
export const deleteOrchard = (id) => api.delete(`/orchards/${id}`).then((r) => r.data);

export const importFarmerOrchardCsv = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/imports/farmer-orchard-csv", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};

export const getAdminStats = () => api.get("/admin/stats").then((r) => r.data);

// ---- Phase 2 — Farmer Interest (public + admin) ----
export const createFarmerInterest = (data) => api.post("/farmer-interests", data).then((r) => r.data);
export const listFarmerInterests = (params = {}) => api.get("/admin/farmer-interests", { params }).then((r) => r.data);
export const updateFarmerInterest = (id, data) => api.patch(`/admin/farmer-interests/${id}`, data).then((r) => r.data);
export const deleteFarmerInterest = (id) => api.delete(`/admin/farmer-interests/${id}`).then((r) => r.data);
export const convertInterestToProfile = (id) => api.post(`/admin/farmer-interests/${id}/convert`).then((r) => r.data);

// ---- Phase 2 — Farmer Registration (farmer self-serve) ----
export const getMyRegistration = () => api.get("/farmer/me/registration").then((r) => r.data);
export const updateMyRegistration = (data) => api.patch("/farmer/me/registration", data).then((r) => r.data);
export const submitMyRegistration = () => api.post("/farmer/me/registration/submit").then((r) => r.data);

// ---- Phase 2 — Registration admin state-machine ----
export const listFarmerProfilesByStatus = (params = {}) => api.get("/admin/farmer-profiles/by-status", { params }).then((r) => r.data);
export const verifyFarmerProfile = (id) => api.post(`/admin/farmer-profiles/${id}/verify`).then((r) => r.data);
export const approveFarmerProfile = (id) => api.post(`/admin/farmer-profiles/${id}/approve`).then((r) => r.data);
export const rejectFarmerProfile = (id, reason) => api.post(`/admin/farmer-profiles/${id}/reject`, { reason }).then((r) => r.data);

// ---- Phase 3 — FPO Interest & Registration ----
export const createFPOInterest = (data) => api.post("/fpo-interests", data).then((r) => r.data);
export const listFPOInterests = (params = {}) => api.get("/admin/fpo-interests", { params }).then((r) => r.data);
export const updateFPOInterest = (id, data) => api.patch(`/admin/fpo-interests/${id}`, data).then((r) => r.data);
export const deleteFPOInterest = (id) => api.delete(`/admin/fpo-interests/${id}`).then((r) => r.data);
export const convertFPOInterest = (id) => api.post(`/admin/fpo-interests/${id}/convert`).then((r) => r.data);
export const listFPOsByStatus = (params = {}) => api.get("/admin/fpos/by-status", { params }).then((r) => r.data);
export const updateFPODraft = (id, data) => api.patch(`/admin/fpos/${id}`, data).then((r) => r.data);
export const submitFPORegistration = (id) => api.post(`/admin/fpos/${id}/submit`).then((r) => r.data);
export const verifyFPO = (id) => api.post(`/admin/fpos/${id}/verify`).then((r) => r.data);
export const approveFPO = (id) => api.post(`/admin/fpos/${id}/approve`).then((r) => r.data);
export const rejectFPO = (id, reason) => api.post(`/admin/fpos/${id}/reject`, { reason }).then((r) => r.data);

// ---- Phase 3 — Buyer Interest & Registration ----
export const createBuyerInterest = (data) => api.post("/buyer-interests", data).then((r) => r.data);
export const listBuyerInterests = (params = {}) => api.get("/admin/buyer-interests", { params }).then((r) => r.data);
export const updateBuyerInterest = (id, data) => api.patch(`/admin/buyer-interests/${id}`, data).then((r) => r.data);
export const deleteBuyerInterest = (id) => api.delete(`/admin/buyer-interests/${id}`).then((r) => r.data);
export const convertBuyerInterest = (id) => api.post(`/admin/buyer-interests/${id}/convert`).then((r) => r.data);
export const listBuyersByStatus = (params = {}) => api.get("/admin/buyers/by-status", { params }).then((r) => r.data);
export const updateBuyerDraft = (id, data) => api.patch(`/admin/buyers/${id}`, data).then((r) => r.data);
export const submitBuyerRegistration = (id) => api.post(`/admin/buyers/${id}/submit`).then((r) => r.data);
export const verifyBuyer = (id) => api.post(`/admin/buyers/${id}/verify`).then((r) => r.data);
export const approveBuyer = (id) => api.post(`/admin/buyers/${id}/approve`).then((r) => r.data);
export const rejectBuyer = (id, reason) => api.post(`/admin/buyers/${id}/reject`, { reason }).then((r) => r.data);

// ---- Phase 4 — Seasons + Seasonal records ----
export const listSeasons = (params = {}) => api.get("/seasons", { params }).then((r) => r.data);
export const createSeason = (data) => api.post("/admin/seasons", data).then((r) => r.data);
export const updateSeason = (id, data) => api.patch(`/admin/seasons/${id}`, data).then((r) => r.data);
export const deleteSeason = (id) => api.delete(`/admin/seasons/${id}`).then((r) => r.data);
export const listSeasonal = (entity, params = {}) => api.get(`/admin/seasonal/${entity}`, { params }).then((r) => r.data);
export const upsertSeasonal = (entity, data) => api.post(`/admin/seasonal/${entity}`, data).then((r) => r.data);
export const updateSeasonal = (entity, id, data) => api.patch(`/admin/seasonal/${entity}/${id}`, data).then((r) => r.data);
export const deleteSeasonal = (entity, id) => api.delete(`/admin/seasonal/${entity}/${id}`).then((r) => r.data);

// ---- Phase 6 — Knowledge ----
export const listKnowledge = (params = {}) => api.get("/knowledge", { params }).then((r) => r.data);
export const getKnowledgeArticle = (slug) => api.get(`/knowledge/${slug}`).then((r) => r.data);
export const adminListKnowledge = () => api.get("/admin/knowledge").then((r) => r.data);
export const createKnowledgeArticle = (data) => api.post("/admin/knowledge", data).then((r) => r.data);
export const updateKnowledgeArticle = (id, data) => api.patch(`/admin/knowledge/${id}`, data).then((r) => r.data);
export const deleteKnowledgeArticle = (id) => api.delete(`/admin/knowledge/${id}`).then((r) => r.data);

// ---- Phase 7 — Reports (return absolute URL for download) ----
export const reportUrl = (name, params = {}) => {
  const qs = new URLSearchParams(params).toString();
  const base = `${process.env.REACT_APP_BACKEND_URL}/api/admin/reports/${name}`;
  return qs ? `${base}?${qs}` : base;
};
